export default "__VITE_ASSET__bOBQI0un__"